import { memo, useState } from 'react';
import { Typography, DialogTitle, DialogContent, DialogActions, Button, Grid, IconButton } from '@material-ui/core';
import Modal from 'modules/views/shared/Modal';
import { useStyles, Accordion, AccordionSummary, AccordionDetails } from './styles';
import { modalGlobalStyles, tableGlobalStyles } from 'assets/styles';
import { releaseNotes } from 'constants/release-notes';
import { getFormattedDate } from 'utils';
import { DateFormat } from 'modules/models/general';
import { CloseOutlined } from '@material-ui/icons';

export interface IReleaseNotesProps {
  show: boolean;
  onClose: () => void;
}

const ReleaseNotes = ({ show, onClose }: IReleaseNotesProps) => {
  const classes = useStyles();
  const tableGlobalClasses = tableGlobalStyles();
  const modalGlobalClasses = modalGlobalStyles();

  return (
    <Modal
      show={show}
      styleClass={`${classes.dialogContainer}`}
      onClose={() => onClose()}
      render={() => (
        <>
          <div className={classes.modalTitle}>
            <DialogTitle disableTypography={true} id="alert-dialog-title">
              <Typography className={modalGlobalClasses.title} color="secondary" align="left" component="h1" variant="h6">
                Release Notes
              </Typography>
              {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                  <CloseOutlined />
                </IconButton>
              ) : null}
            </DialogTitle>
          </div>

          <DialogContent className={`${tableGlobalClasses.tableWrapper} ${tableGlobalClasses.tableBackground}`}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {Object.entries(releaseNotes).map(([version, releaseNote], index) => (
                  <Accordion defaultExpanded={index === 0} key={version}>
                    <AccordionSummary>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Typography>
                          {version} <small>{index === 0 ? '(latest)' : ''}</small>
                        </Typography>
                        <Typography>{getFormattedDate(releaseNote.createdAt, DateFormat.MONTH_YEAR)}</Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails style={{ overflowY: 'auto', maxHeight: 500, marginBottom: 10 }}>
                      {releaseNote.notes.map((note, index) => (
                        <div key={index} dangerouslySetInnerHTML={{ __html: note }}></div>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ marginTop: '20px' }}>
            <Button onClick={() => onClose()} color="primary" data-testid="assign-btn-close">
              Close
            </Button>
          </DialogActions>
        </>
      )}
    />
  );
};

export default memo(ReleaseNotes);
